// Polyfill for promises
import es6Promise from 'es6-promise';
es6Promise.polyfill();

import Vuex from 'vuex';
import Vue from 'vue';
import mutations from './mutations';
import * as actions from './actions';

import comms from './modules/comms';
import confirm from './modules/confirm';
import contact from './modules/contact';
import done from './modules/done';
import meeting from './modules/meeting';
import ownership from './modules/ownership';
import proxy from './modules/proxy';
import questions from './modules/questions';
import resident from './modules/resident';
import voter from './modules/voter';
import candidates from './modules/candidates';

Vue.use(Vuex);

const state = {
  errors: {
    message: ''
  },
  steps: {
    current: 0,
    next: 0,
    previous: 0,
    // used to define the paths user takes through the app
    pathing: [
      '/',
      '/ownership',
      '/questions',
      '/proxy',
      '/comms',
      '/review',
      '/confirm'
    ],
    stepMap: [
      {label: 'Start', subtitle: 'Overview', startIndex: 0, path: '/'},
      {label: 'Questions', subtitle: '', startIndex: 0, path: '/ownership'},
      {label: 'Finish', subtitle: 'Review', startIndex: 0, path: '/review'}
    ],
    isResidentRequired: false,
    nextReview: false
  },
  proxyContentResponse: {
    status: 0
  },
  token: '',
  trackingCode: '',
  shortCode: '',
  commitCode: '',
  appDisplayOptions: {},
  meetingOptions: {},
  showRsvpModal: false,
  showRevokeModal: false,
  blockUnverifiedVoting: false,
  customSignature: null,
  previewMode: false
};

const getters = {
  displayOptions: state => state.appDisplayOptions,
  meetingOptions: state => state.meetingOptions,
  error: state => state.errors,
  shortCode: state => state.shortCode,
  steps: state => state.steps,
  trackingCode: state => state.trackingCode,
  token: state => state.token,
  showRsvpModal: state => state.showRsvpModal,
  showRevokeModal: state => state.showRevokeModal,
  blockUnverifiedVoting: state => state.blockUnverifiedVoting,
  customSignature: state => state.customSignature,
  previewMode: state => state.previewMode,

  // Get the timezone based on meeting timezone or use Toronto as default
  timezone: state => {
    return state.meeting.meetingTimezone
      ? state.meeting.meetingTimezone
      : 'America/Toronto';
  }
};

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    comms,
    confirm,
    contact,
    done,
    meeting,
    ownership,
    proxy,
    questions,
    resident,
    voter,
    candidates
  }
});

export default store;
